/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:f9b0a105-4efc-4052-ae45-ab1c15c9982a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_o2d7FPiLR",
    "aws_user_pools_web_client_id": "4t9lbhdpth4phfi908rapgvbkb",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_user_files_s3_bucket": "sagestoragetime145131-dev",
    "oauth": {
        "domain": "growmyownfood.auth.us-east-1.amazoncognito.com",
        "scope": ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
        "redirectSignIn": `${window.location.origin}/`,
        "redirectSignOut": `${window.location.origin}/login`,
        "responseType": "code"
    },
};


export default awsmobile;
